import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showOptionCheckmark',
})
export class SelectShowOptionCheckmarkPipe implements PipeTransform {
  transform(value: unknown, selectedValue: unknown): boolean {
    if (value === undefined || selectedValue === undefined) {
      return false;
    }

    if (Array.isArray(selectedValue)) {
      return selectedValue.some((item: unknown) => item === value);
    }

    return selectedValue === value;
  }
}
